import CreateTasksLightbox from '../addNewTasks/CreateTasksLightbox'
import CorporateScheduleCalculator from '../controls/dateControls/CorporateScheduleCalculator'
import {loadPopupContentByRpcCall} from '../util/PopupLoadingUtils'
import messageResource from '../messageResource'
import {unsafe_bindActions} from '../redux/utils'
import {bindActionCreators} from 'redux'
import {isCustomerIdValid, isProjectIdValid} from './utils'
import {setTypesOfWorkList} from '../entities/actions'

export default class CreateTasksPopupController {
    constructor({
        successTaskCreationCb,
        serviceName
    }) {

        this.actions = unsafe_bindActions((dispatch) => ({
            setTypesOfWorkList: bindActionCreators(setTypesOfWorkList, dispatch)
        }))

        this.callbacks = {
            successTaskCreationCb,
        }

        this.params = {
            serviceName,
        }
    }

    showPopup(selectedCustomerId, selectedProjectId, selectedUserId, openedFromOpenTasks, dayOnWeek) {
        this._requestPopupData(selectedCustomerId, selectedProjectId, selectedUserId, openedFromOpenTasks, dayOnWeek,
            (contentData) => {
                new CreateTasksLightbox(
                    this.params.serviceName,
                    contentData,
                    {successTaskCreationCallback: this.callbacks.successTaskCreationCb}
                ).init().show()
            },
            (jqXHR, textStatus, errorThrown) => {
                if (textStatus === "rpc_customException") {
                    if (errorThrown.exception === "com.actimind.actitime.services.BaseNewTasksService$NoAssignedProjectsException") {
                        alert(messageResource.getMessage("add_new_tasks.no_projects_assigned.error"))
                        window.location.reload()
                        return true
                    }
                }
                return false
            }
        )
    }

    _requestPopupData(selectedCustomerId, selectedProjectId, selectedUserId, openedFromOpenTasks, dayOnWeek, onSuccessCb, onErrorCb) {
        loadPopupContentByRpcCall(this.params.serviceName + ".getCreateNewTasksData", [],
            (data) => {
                const newTasksPopupData = data['details']
                const customers = data['customers'].list
                const projects = data['projects'].list

                const billingTypes = newTasksPopupData.billingTypes ? newTasksPopupData.billingTypes.list : null
                const defaultBillingTypeId = newTasksPopupData.defaultBillingTypeId
                if (newTasksPopupData.billingTypes) this.actions.setTypesOfWorkList(newTasksPopupData.billingTypes.list)

                const corporateSchedule = data['corporateSchedule']
                const scheduleCalculator = new CorporateScheduleCalculator().init(window.invertedDaysDateMap, corporateSchedule)

                const weekStartDay = data['weekStartDay'] - 1

                const userManagementAssignmentsData = data['userManageAssignmentsData']
                const canEditHierarchy = newTasksPopupData.canEditHierarchy
                const canAddTasksToUser = newTasksPopupData.canAddTaskToTT

                const isEstEnabled = data['estEnabled']

                const userSettings = data['userSettings']
                const selectedCustomerIdFromSettings = userSettings['lastCustomerId']
                const selectedProjectIdFromSettings = userSettings['lastProjectId']
                const customerId = selectedCustomerId === null && isCustomerIdValid(customers, selectedCustomerIdFromSettings) ?
                                   selectedCustomerIdFromSettings : selectedCustomerId
                const projectId = selectedProjectId === null && isProjectIdValid(projects, selectedProjectIdFromSettings) ?
                                  selectedProjectIdFromSettings : selectedProjectId

                const projectsWithTasksExist = newTasksPopupData.projectsWithTasksExist

                const user = data['user']

                onSuccessCb({
                    customers: customers,
                    projects: projects,
                    billingTypes: billingTypes,
                    defaultBillingTypeId: defaultBillingTypeId,
                    canEditHierarchy: canEditHierarchy,
                    canAddTasksToUser: canAddTasksToUser,
                    weekStartDay: weekStartDay,
                    scheduleCalculator: scheduleCalculator,
                    estEnabled: isEstEnabled,
                    projectsWithTasksExist: projectsWithTasksExist,
                    isOpenedFromOpenTasks: openedFromOpenTasks,
                    selectedCustomerId: customerId,
                    selectedProjectId: projectId,
                    selectedUserId: selectedUserId,
                    user: user,
                    dayOnWeek: dayOnWeek,
                    userManagementAssignmentsData: userManagementAssignmentsData
                })
            },
            true,
            onErrorCb,
            true)
    }
}



// WEBPACK FOOTER //
// ./web/js/addNewTasks/CreateTasksPopupController.js